import React, { useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { Link } from "react-router-dom";

import AOS from "aos";
import "aos/dist/aos.css";

import logo from "../assets/img/LOGO-white.png";

import img1 from "../assets/img/homepage/img1.png";
import img2 from "../assets/img/homepage/img2.png";
import img3 from "../assets/img/homepage/img3.png";
import img4 from "../assets/img/homepage/img4.jpeg";

export default function TravelSection() {
  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  return (
    <section className="travel-section container-fluid py-5">
      <Container>
        <Row className="align-items-center tour-hightlight-section">
          {/* LEFT IMAGES */}
          <Col
            xs={12}
            md={4}
            className="text-center text-md-end order-1 order-md-1"
            data-aos="fade-right"
          >
            <div className="image-grid-left">
              <img src={img1} className="img1" alt="Tour 1" />
              <img src={img2} className="img2" alt="Tour 2" />
            </div>
          </Col>

          {/* CENTER TEXT */}
          <Col
            xs={12}
            md={4}
            className="text-center order-2 order-md-2"
            data-aos="zoom-in"
          >
            <div className="tour-text">
              <img src={logo} alt="logo" className="travelsection-logo z-n1" />

              <h2 className="mt-3 new-font">Most Popular Tour</h2>

              <h1
                className="fw-bold mb-3"
                style={{ margin: "2px", color: "#000" }}
              >
                Let’s Discover Andaman <br /> With Our Eyes
              </h1>

              <p className="text-muted mb-4">
                Whether you’re looking for a romantic getaway or a solo journey
                to explore Andaman, our travel agency can provide a tailored
                itinerary that exceeds your expectations.
              </p>

              <Link
                to="/tour-packages"
                variant="primary"
                className="take-tour-btn m-3 d-none d-md-inline-block"
              >
                TAKE A TOUR <i className="bi bi-arrow-right ms-2" />
              </Link>
            </div>
          </Col>

          {/* RIGHT IMAGES */}
          <Col
            xs={12}
            md={4}
            className="text-center text-md-start order-3 order-md-3"
            data-aos="fade-left"
          >
            <div className="image-grid-right">
              <img src={img3} className="img1" alt="Tour 3" />
              <img src={img4} className="img2" alt="Tour 4" />
            </div>
          </Col>

          {/* MOBILE BUTTON */}
          <Col
            xs={12}
            className="text-center order-4 d-md-none mt-3"
            data-aos="fade-up"
          >
            <Button variant="primary" className="take-tour-btn">
              TAKE A TOUR <i className="bi bi-arrow-right ms-2" />
            </Button>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
